jQuery.fn.getFormDataAssociative = function () {
    let fd = new FormData();
    let f = this.serializeArray();
    for (let k in f) {
        if (f.hasOwnProperty(k)) {
            fd.append(f[k].name, f[k].value);
        }
    }

    this.find('input[type="file"]').each((k, v) => {
        for (let fk in v.files) {
            if (v.files.hasOwnProperty(fk))
                fd.append($(v).attr('name'), v.files[fk] ?? '');
        }
    });

    return fd;
}

jQuery.fn.fillFormErrors = function (err) {
    let f = $(this[0]);

    /** Clear old validation errors */
    f.find('input, textarea, select').each(function () {
        $(this).removeClass('is-invalid')
        $(this).closest('.form-group')
            .find('> .invalid-feedback')
            .removeClass('d-block')
            .text('')
    });

    for (let k in err) {
        if (err.hasOwnProperty(k)) {
            let message = err[k] instanceof Array ? err[k][0] : err[k]
            let formElement = f.find('[name="' + k + '"]')

            if (!formElement.length) {
                formElement = f.find('[name="' + k + '[]"]')
            }

            if (!formElement.length && k.includes('.')) {
                const splittedKey = k.split('.');
                let fieldName = '';
                for (let formElementKey in splittedKey) {
                    if (formElementKey === '0') {
                        fieldName += splittedKey[formElementKey]
                        continue;
                    }

                    fieldName += '[' + splittedKey[formElementKey] + ']';
                }

                formElement = f.find('[name="' + fieldName + '"]');

                if (!formElement.length) {
                    let fieldIndex;
                    fieldName = '';

                    for (const formElementKey in splittedKey) {
                        if (formElementKey === '0') {
                            fieldName += splittedKey[formElementKey]
                            continue;
                        }

                        if (!isNaN(splittedKey[formElementKey])) {
                            fieldIndex = splittedKey[formElementKey];
                            fieldName += '[]';
                            continue;
                        }

                        fieldName += '[' + splittedKey[formElementKey] + ']';
                    }

                    formElement = f.find('[name="' + fieldName + '"]')[fieldIndex];
                    // check if formElement is jquery object
                    if (formElement !== undefined && formElement.length === undefined) {
                        formElement = $(formElement);
                    }
                }
            }

            if (formElement === undefined || !formElement.length) {
                continue;
            }

            formElement.addClass('is-invalid')
                .closest('.form-group')
                .find('> .invalid-feedback')
                .addClass('d-block')
                .text(message);
        }
    }
}

/**
 * Remove validation message when changing
 * */
$(document).on('change', 'input, select, textarea', function () {
    let formElem = $(this);
    if (!formElem.hasClass('is-invalid')) {
        return;
    }

    formElem.removeClass('is-invalid')
    formElem.closest('.form-group')
        .find('.invalid-feedback')
        .removeClass('d-block')
        .text('')
})
